import React from 'react';
import divider from '../../assets/divider-img.png';

const CustomisedDataAnalysis = () => {
  return (
    <div className="cust-data-analysis">
      <div className="container">
        <div className="center-heading-description">
          <h2>Data Acquisition and Analysis</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            Unleash Market Insights with our Dynamic Data Acquisition and
            Analysis: Harness the power of real-time data from diverse sources
            to gain comprehensive market insights. Our advanced analytics tools
            aid in trend identification, pattern recognition, and
            decision-making, ensuring that your trades are always backed by
            data-driven precision.
          </p>
        </div>
        <div className="cust-data-analysis-wrapper">
          <div className="cust-data-analysis-item cust-data-analysis-item-one"></div>
          <div className="cust-data-analysis-item cust-data-analysis-item-two"></div>
          <div className="cust-data-analysis-item cust-data-analysis-item-three"></div>
          <div className="cust-data-analysis-item cust-data-analysis-item-four"></div>
          <div className="cust-data-analysis-item cust-data-analysis-item-five"></div>
        </div>
      </div>
    </div>
  );
};

export default CustomisedDataAnalysis;
